var map = {
	"./AllFooter/index.vue": "7912",
	"./DetailsCharts/index.vue": "71e3",
	"./DetailsHeader/index.vue": "1037",
	"./MerchantsHeader/index.vue": "1f56",
	"./MerchantsRelease/index.vue": "4c99",
	"./MerchantsReleaseHot/index.vue": "8695",
	"./PriceItem/index.vue": "1936",
	"./Recommended/index.vue": "44c5",
	"./TabHeader/index.vue": "c3fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8326";